import React, { useState } from "react";
import { GameClient } from "../gameClient";
import { setDismissedEAPopup } from "../userSettings";
import { Modal } from "./Modal";
/** @jsx jsx */
import { jsx } from '@emotion/react';
/* @ts-ignore */
import { css } from '@emotion/react';

interface EAPopupProps {
}

declare var gameClient: GameClient;

const checkboxStyle = css`
  margin-bottom: 1rem;

  input[type="checkbox"] {
    transform: scale(1.5);
    margin-right: 1rem;
  }
`;

export const EAPopup = (props: EAPopupProps) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const onClose = () => {
    setDismissedEAPopup(dontShowAgain);
  }

  const handleDontShowAgain = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDontShowAgain(event.target.checked);
  }
  return (
    <Modal onClose={onClose} isOpen={true} height="fit-content" width="30vw">
      <h1>Welcome to Auto Immune Early Access!</h1>
      <p>
        The game is in active development with new content added regularly.
      </p>

      <p>
        There may be bugs, especially in the experimental Multiplayer and Endless modes. Please report any issues you encounter on the Steam forums or on the Auto Immune discord.
      </p>

      <p>
        All feedback is deeply appreciated. Community involvment is essential to our development plan.
      </p>

      <p>
        Thanks for playing and have fun!
      </p>

      <p>
        -- Devs
      </p>
      <div css={checkboxStyle}>
        <input type="checkbox" id="tutorial" name="tutorial" checked={dontShowAgain} onChange={handleDontShowAgain} />
        <label htmlFor="tutorial">Don't Show Again</label>
      </div>
    </Modal >
  )
}
